var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 71.54 94.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:url(#radial-gradient);}.cls-3{opacity:0.17;}.cls-4{fill:#320f32;}.cls-5{fill:#673434;}.cls-6{fill:#650a34;}.cls-7{fill:#033434;}.cls-8{fill:#bce4ea;}.cls-9{fill:url(#radial-gradient-2);}.cls-10{fill:url(#radial-gradient-3);}.cls-11{fill:url(#radial-gradient-4);}.cls-12{fill:url(#radial-gradient-5);}.cls-13{fill:url(#radial-gradient-6);}.cls-14{fill:url(#radial-gradient-7);}.cls-15{fill:url(#radial-gradient-8);}.cls-16{fill:url(#radial-gradient-9);}.cls-17{fill:url(#radial-gradient-10);}.cls-18{fill:url(#radial-gradient-11);}.cls-19{fill:#333;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 35.77,
    cy: -131.46,
    r: 38.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#046983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#049898"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 35.77,
    cy: -135.47,
    r: 6.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 35.79,
    cy: -142.34,
    r: 21.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#049898"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 35.78,
    cy: -144.61,
    r: 21.5,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 35.78,
    cy: -146.87,
    r: 21.5,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 5.89,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 8.74,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 11.59,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 59.9,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 62.74,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 65.59,
    cy: -135.47,
    r: 1.05,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.07,20.36h0a3.47,3.47,0,0,0-1.28-1.27L37.53.48A3.6,3.6,0,0,0,35.77,0h0A3.56,3.56,0,0,0,34,.48L1.78,19.09a3.5,3.5,0,0,0-1.3,1.29A3.4,3.4,0,0,0,0,22.14V59.39a3.71,3.71,0,0,0,.48,1.78H.53a3.39,3.39,0,0,0,1.25,1.27L34,81a3.68,3.68,0,0,0,1.78.48h0a3.58,3.58,0,0,0,1.72-.47L69.78,62.44a3.55,3.55,0,0,0,1.29-1.29,3.66,3.66,0,0,0,.47-1.74V22.14A3.7,3.7,0,0,0,71.07,20.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.07,20.36h0a3.47,3.47,0,0,0-1.28-1.27L37.53.48A3.6,3.6,0,0,0,35.77,0h0A3.56,3.56,0,0,0,34,.48L1.78,19.09a3.5,3.5,0,0,0-1.3,1.29A3.4,3.4,0,0,0,0,22.14V59.39a3.71,3.71,0,0,0,.48,1.78H.53a3.39,3.39,0,0,0,1.25,1.27L34,81a3.68,3.68,0,0,0,1.78.48h0a3.58,3.58,0,0,0,1.72-.47L69.78,62.44a3.55,3.55,0,0,0,1.29-1.29,3.66,3.66,0,0,0,.47-1.74V22.14A3.7,3.7,0,0,0,71.07,20.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.78,19.09,37.53.48A3.57,3.57,0,0,0,35.75,0h0L22.17,17.22l11.19-1.66a16.85,16.85,0,0,1,4.81,0l32.9,4.82h0A3.55,3.55,0,0,0,69.78,19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34,.48,1.78,19.09a3.5,3.5,0,0,0-1.3,1.29h0L8.57,40.75l4.16-10.52a16.27,16.27,0,0,1,2.4-4.16L35.77,0h0A3.46,3.46,0,0,0,34,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,22.14V59.39a3.71,3.71,0,0,0,.48,1.78h0l21.69,3.18-7-8.91a16.27,16.27,0,0,1-2.4-4.16L.48,20.38h0A3.4,3.4,0,0,0,0,22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.78,62.44,34,81a3.68,3.68,0,0,0,1.78.48h0l13.6-17.23-11.2,1.65a16.85,16.85,0,0,1-4.81,0L.48,61.14h0A3.52,3.52,0,0,0,1.78,62.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.53,81l32.25-18.6a3.71,3.71,0,0,0,1.29-1.29h0L63,40.75,58.8,51.28a16.86,16.86,0,0,1-2.38,4.16L35.77,81.49h0A3.47,3.47,0,0,0,37.53,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.53,81l32.25-18.6a3.55,3.55,0,0,0,1.29-1.29h0L63,40.75,58.8,51.28a16.86,16.86,0,0,1-2.38,4.16L35.77,81.49h0A3.47,3.47,0,0,0,37.53,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.54,59.39V22.14a3.7,3.7,0,0,0-.47-1.78h0l-21.7-3.14,7.05,8.86a16.5,16.5,0,0,1,2.38,4.16L71.07,61.12h0A3.51,3.51,0,0,0,71.54,59.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M35.8,78.53a3.64,3.64,0,0,1-1.73-.46L4.34,60.9a3.36,3.36,0,0,1-1.2-1.14h0l-.07-.08a3.54,3.54,0,0,1-.46-1.74V23.6a3.47,3.47,0,0,1,.46-1.73,3.56,3.56,0,0,1,1.27-1.23L34.05,3.46A3.4,3.4,0,0,1,35.75,3h0a3.61,3.61,0,0,1,1.72.47L67.21,20.64A3.47,3.47,0,0,1,68.4,21.8h0l.06.08a3.64,3.64,0,0,1,.46,1.73V58a3.44,3.44,0,0,1-1.72,3L37.49,78.06a3.41,3.41,0,0,1-1.59.46h-.1ZM3.36,59.42l.06.06a3,3,0,0,0,1.11,1.06l29.73,17.2a3.18,3.18,0,0,0,1.48.4h.07a3,3,0,0,0,1.49-.4L67,60.57a3.06,3.06,0,0,0,1.53-2.63V23.6a3.36,3.36,0,0,0-.38-1.49l0-.06A3.19,3.19,0,0,0,67,20.94L37.3,3.79a3.12,3.12,0,0,0-1.52-.41h0a3,3,0,0,0-1.52.41L4.53,20.94A3.14,3.14,0,0,0,3.4,22.07,3,3,0,0,0,3,23.6V57.93A3.36,3.36,0,0,0,3.36,59.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.84,51.63a13.67,13.67,0,0,1-9.09-6.88,13.7,13.7,0,0,1,9.06-6.86,7.48,7.48,0,0,0-4,9.8,7.38,7.38,0,0,0,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.79,44.76a13.65,13.65,0,0,1-9.08,6.88,7.48,7.48,0,0,0,0-13.76A13.68,13.68,0,0,1,47.79,44.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.77,34.86a18.42,18.42,0,0,0-16.26,9.72l-.1.18.1.19A18.46,18.46,0,0,0,52,45l.1-.19-.1-.18A18.42,18.42,0,0,0,35.77,34.86Zm0,19A17.68,17.68,0,0,1,20.9,45.79a1.9,1.9,0,0,1,0-2,17.7,17.7,0,0,1,29.75,0,1.9,1.9,0,0,1,0,2A17.69,17.69,0,0,1,35.77,53.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66,42.14a.38.38,0,0,1-.38.38h-7c-.17-.25-.35-.52-.53-.76A27.53,27.53,0,0,0,49.47,34h0a9.71,9.71,0,0,0-1-.53,26.16,26.16,0,0,0-2.92-1.29l-1.09-.4a28.6,28.6,0,0,0-3.27-.86l-1.25-.22a27.64,27.64,0,0,0-4.16-.31,27.25,27.25,0,0,0-4.13.31c-.41.06-.83.14-1.24.22a26,26,0,0,0-3.27.81c-.37.12-.73.25-1.09.39a28.3,28.3,0,0,0-2.93,1.29h0l-1,.53a27.55,27.55,0,0,0-8.67,7.8c-.19.25-.37.53-.53.76h-7a.4.4,0,0,1-.39-.38.39.39,0,0,1,.39-.38h5.6A1.91,1.91,0,0,0,13,41a28.38,28.38,0,0,1,9.46-8.1c.34-.19.69-.36,1.06-.53a26.33,26.33,0,0,1,3.07-1.25c.38-.14.75-.25,1.14-.37A26.49,26.49,0,0,1,31.29,30c.43-.08.87-.14,1.31-.18a27.94,27.94,0,0,1,3.17-.18,28.69,28.69,0,0,1,3.22.18c.44.05.88.11,1.31.18a26.69,26.69,0,0,1,3.54.81,11.4,11.4,0,0,1,1.13.36,24.88,24.88,0,0,1,3.08,1.26c.35.16.69.33,1.06.53A28.32,28.32,0,0,1,58.54,41a1.91,1.91,0,0,0,1.52.75h5.56a.37.37,0,0,1,.39.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M59.8,44.38H57.26a1.89,1.89,0,0,1-1.63-.91,23.27,23.27,0,0,0-39.69,0,1.91,1.91,0,0,1-1.65.91H5.91a.4.4,0,0,0-.39.38h0a.39.39,0,0,0,.39.39h8.38a1.88,1.88,0,0,1,1.62.89,23.29,23.29,0,0,0,39.72,0,1.88,1.88,0,0,1,1.63-.91h8.36a.39.39,0,0,0,.38-.39h0a.38.38,0,0,0-.38-.38H59.8Zm-24,12A22.49,22.49,0,0,1,16.05,44.79a22.49,22.49,0,0,1,39.44,0A22.46,22.46,0,0,1,35.77,56.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.65,47c-.18.27-.35.53-.53.77a27.63,27.63,0,0,1-44.68,0c-.18-.25-.36-.53-.53-.77h-7a.39.39,0,0,0-.39.39h0a.4.4,0,0,0,.39.38h5.6a1.89,1.89,0,0,1,1.52.75,28.4,28.4,0,0,0,45.48,0A1.9,1.9,0,0,1,60,47.77h5.59a.38.38,0,0,0,.38-.38h0a.39.39,0,0,0-.38-.39h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36,25.06,35.8,25l-.18.1a18.69,18.69,0,0,0-4.33,3.22c-.3.31-.59.61-.87.94.41-.08.83-.16,1.25-.22a11.21,11.21,0,0,1,.93-.89c.33-.28.72-.62,1.11-.92a3.5,3.5,0,0,1,4.19,0c.39.3.76.6,1.12.92s.63.58.93.89c.42.07.84.14,1.25.23-.28-.33-.58-.64-.88-.94A18.58,18.58,0,0,0,36,25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.74,21.89a3.53,3.53,0,0,1-1.59-2.95V11.08H35.4V19a3.51,3.51,0,0,1-1.59,2.93,23.33,23.33,0,0,0-7.21,7.55c-.19.34-.39.68-.56,1,.36-.14.72-.27,1.09-.38.19-.34.39-.67.6-1a22.46,22.46,0,0,1,6-6.22,3.53,3.53,0,0,1,4.05,0,22.39,22.39,0,0,1,6,6.24c.22.33.42.66.61,1,.37.12.73.25,1.09.39-.18-.35-.37-.69-.57-1A23.15,23.15,0,0,0,37.74,21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.78,19l.76-.53V11.08h-.76v5.19a3.63,3.63,0,0,1-1.38,2.78,28.39,28.39,0,0,0-8.91,12.17l-.39,1.09c.33-.19.67-.37,1-.53h0c.13-.35.27-.71.42-1.06A27.53,27.53,0,0,1,32.78,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.08,31.22a28.25,28.25,0,0,0-8.91-12.17,3.54,3.54,0,0,1-1.38-2.8V11.06H38v7.39c.26.17.53.35.77.53a27.56,27.56,0,0,1,9.26,11.71c.15.36.28.71.41,1.06.35.17.68.36,1,.53C49.35,32,49.21,31.6,49.08,31.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 35.77,
    cy: 44.76,
    r: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M65.14,50.8a10.65,10.65,0,0,1-19.36,1,4.34,4.34,0,0,0-.26-.53,10.12,10.12,0,0,0-1-1.54,13.37,13.37,0,0,0-1.06-1.2,11.06,11.06,0,0,0-15.61,0A10.67,10.67,0,0,0,26,51.11a6,6,0,0,1-.34.67v0a10.62,10.62,0,0,1-17.2,2.11,10.27,10.27,0,0,1-2-3.12H6a10.75,10.75,0,0,0,1.91,3.14,11,11,0,0,0,15.52,1.2,11.53,11.53,0,0,0,1.62-1.73A9.87,9.87,0,0,0,26,52h0c.11-.2.23-.42.32-.63v0a10.65,10.65,0,0,1,18.84.11,5,5,0,0,1,.28.57,10.81,10.81,0,0,0,.93,1.48A11,11,0,0,0,65.54,50.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.14,53.08a10.67,10.67,0,0,1-19.36,1,5.2,5.2,0,0,0-.26-.53,10.44,10.44,0,0,0-1-1.52,11.15,11.15,0,0,0-16.67-1.2,9,9,0,0,0-1,1.14A8.84,8.84,0,0,0,26,53.39a7.18,7.18,0,0,1-.34.68h0a10.63,10.63,0,0,1-14.41,4.29A10.72,10.72,0,0,1,6.45,53H6a10.75,10.75,0,0,0,1.91,3.14,11,11,0,0,0,15.52,1.2,10.64,10.64,0,0,0,1.62-1.73A10.37,10.37,0,0,0,26,54.26h0c.11-.21.23-.42.32-.63h0a10.66,10.66,0,0,1,18.84.11,5,5,0,0,1,.28.57,10.81,10.81,0,0,0,.93,1.48,11,11,0,0,0,19.16-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M65.14,55.35a10.66,10.66,0,0,1-19.36,1,5.2,5.2,0,0,0-.26-.53,10.44,10.44,0,0,0-1-1.52A11.15,11.15,0,0,0,27.9,53.1a9,9,0,0,0-1,1.14A9.31,9.31,0,0,0,26,55.66a6.16,6.16,0,0,1-.34.68v0a10.64,10.64,0,0,1-19.2-1H6a11,11,0,0,0,19,2.59A9.77,9.77,0,0,0,26,56.55h0c.11-.21.23-.42.32-.63h0a10.67,10.67,0,0,1,16.94-2.49A10.94,10.94,0,0,1,45.15,56a6.19,6.19,0,0,1,.28.58,10.81,10.81,0,0,0,.93,1.48,11,11,0,0,0,19.16-2.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 5.89,
    cy: 44.76,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 8.74,
    cy: 44.76,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 11.59,
    cy: 44.76,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 59.9,
    cy: 44.76,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 62.74,
    cy: 44.76,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 65.59,
    cy: 44.76,
    r: 1.05
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M6.11,92.42V85H7.59l3,5.38h-.26V85h1.39v7.4H10.23L7.24,87h.25v5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M13.92,92.52a1.52,1.52,0,0,1-1.11-.42A1.55,1.55,0,0,1,12.39,91a1.61,1.61,0,0,1,.47-1.22,2.6,2.6,0,0,1,1.55-.52l.87-.07.2.85-.91.07a.87.87,0,0,0-.57.22.69.69,0,0,0-.19.51.66.66,0,0,0,.17.49.6.6,0,0,0,.44.16.93.93,0,0,0,.35-.08.82.82,0,0,0,.33-.27V89a1.4,1.4,0,0,0-.1-.56.62.62,0,0,0-.34-.29,2,2,0,0,0-.61-.08,3.59,3.59,0,0,0-.62,0,5.18,5.18,0,0,0-.66.14V87.06a5.31,5.31,0,0,1,.77-.14,7.45,7.45,0,0,1,.79,0,3.29,3.29,0,0,1,1.23.2,1.41,1.41,0,0,1,.72.68A3.05,3.05,0,0,1,16.51,89v3.39H15.33l-.11-.57h-.07a1.19,1.19,0,0,1-.52.52A1.64,1.64,0,0,1,13.92,92.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M17.36,92.42V87h1.21l.11.58h.07a1.65,1.65,0,0,1,.6-.49,1.62,1.62,0,0,1,.77-.17,1.66,1.66,0,0,1,.78.18,1.3,1.3,0,0,1,.55.6,2.72,2.72,0,0,1,.2,1.13v3.64H20.2V88.89a.76.76,0,0,0-.17-.57.61.61,0,0,0-.43-.16.92.92,0,0,0-.28,0,.79.79,0,0,0-.28.13,1,1,0,0,0-.22.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M24.57,92.53a2.45,2.45,0,0,1-1.24-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.4,2.4,0,0,1,1.24-.3,2.37,2.37,0,0,1,1.22.3,1.94,1.94,0,0,1,.79.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,24.57,92.53Zm0-1.1A.66.66,0,0,0,25,91.3a.87.87,0,0,0,.27-.51,4.14,4.14,0,0,0,.1-1.07,4.46,4.46,0,0,0-.1-1.1A.94.94,0,0,0,25,88.1a.68.68,0,0,0-.42-.14.69.69,0,0,0-.43.14.87.87,0,0,0-.27.51,4.37,4.37,0,0,0-.1,1.09,4.28,4.28,0,0,0,.1,1.08.94.94,0,0,0,.27.52A.67.67,0,0,0,24.57,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M27.51,94.62V87h1.23l.1.6h.07a1.27,1.27,0,0,1,.46-.49,1.25,1.25,0,0,1,.72-.19,1.73,1.73,0,0,1,.93.27,1.89,1.89,0,0,1,.7.87A3.9,3.9,0,0,1,32,89.59a4,4,0,0,1-.29,1.62,2.09,2.09,0,0,1-.9,1,3.24,3.24,0,0,1-1.55.33h-.14l-.14,0v2.12Zm1.86-3.22a1,1,0,0,0,.84-.36,2.2,2.2,0,0,0,.29-1.31,3.29,3.29,0,0,0-.12-1,.87.87,0,0,0-.31-.49.86.86,0,0,0-.46-.13.94.94,0,0,0-.36.08.71.71,0,0,0-.28.23v3l.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M32.61,92.42V84.34h1.46v3.19h.07a1.55,1.55,0,0,1,.53-.49,1.65,1.65,0,0,1,.77-.17,1.49,1.49,0,0,1,.73.18,1.26,1.26,0,0,1,.53.6,2.74,2.74,0,0,1,.2,1.14v3.63H35.45V88.91a.79.79,0,0,0-.17-.58.57.57,0,0,0-.43-.16,1,1,0,0,0-.28,0,.88.88,0,0,0-.28.13,1,1,0,0,0-.22.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.82,92.53a2.45,2.45,0,0,1-1.24-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.4,2.4,0,0,1,1.24-.3,2.37,2.37,0,0,1,1.22.3,1.94,1.94,0,0,1,.79.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,39.82,92.53Zm0-1.1a.66.66,0,0,0,.42-.13.87.87,0,0,0,.27-.51,4.14,4.14,0,0,0,.1-1.07,4.46,4.46,0,0,0-.1-1.1.94.94,0,0,0-.27-.52.68.68,0,0,0-.42-.14.69.69,0,0,0-.43.14.87.87,0,0,0-.27.51A4.37,4.37,0,0,0,39,89.7a4.28,4.28,0,0,0,.1,1.08.94.94,0,0,0,.27.52A.67.67,0,0,0,39.82,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M42.14,88.1V87h3.5V88.1Zm2.65,4.42a1.94,1.94,0,0,1-1.38-.47,2.07,2.07,0,0,1-.48-1.54V87L43.19,85h1.19v5.32a1.13,1.13,0,0,0,.18.73.79.79,0,0,0,.6.2h.24l.27,0v1.19a3.51,3.51,0,0,1-.42.08A3.55,3.55,0,0,1,44.79,92.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M48.19,92.53a2.39,2.39,0,0,1-1.23-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.67,2.67,0,0,1,2.46,0,2,2,0,0,1,.78.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,48.19,92.53Zm0-1.1a.69.69,0,0,0,.43-.13.87.87,0,0,0,.27-.51A4.76,4.76,0,0,0,49,89.72a5.13,5.13,0,0,0-.09-1.1,1,1,0,0,0-.28-.52.64.64,0,0,0-.42-.14.71.71,0,0,0-.43.14,1,1,0,0,0-.27.51,5,5,0,0,0-.09,1.09,4.92,4.92,0,0,0,.09,1.08,1.09,1.09,0,0,0,.27.52A.69.69,0,0,0,48.19,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M51.14,92.42V87h1.21l.11.58h.06a1.76,1.76,0,0,1,2.15-.48,1.2,1.2,0,0,1,.55.6,2.56,2.56,0,0,1,.21,1.13v3.64H54V88.89a.76.76,0,0,0-.16-.57.64.64,0,0,0-.44-.16,1,1,0,0,0-.28,0,.75.75,0,0,0-.27.13,1,1,0,0,0-.23.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M57,86.15a1,1,0,0,1-.69-.22.91.91,0,0,1,0-1.21,1.19,1.19,0,0,1,1.38,0,.82.82,0,0,1,.22.61.81.81,0,0,1-.22.6A1,1,0,0,1,57,86.15Zm-.73,6.27V87h1.46v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M60.81,92.53a2.67,2.67,0,0,1-1.31-.3,1.86,1.86,0,0,1-.82-.92,3.9,3.9,0,0,1-.28-1.62,3.61,3.61,0,0,1,.31-1.63,2,2,0,0,1,.91-.91A3.13,3.13,0,0,1,61,86.87l.49,0L62,87v1.2a2.25,2.25,0,0,0-.36-.06h-.34a1.7,1.7,0,0,0-.77.15.94.94,0,0,0-.45.49,2.42,2.42,0,0,0-.14.94,2.93,2.93,0,0,0,.13,1,.94.94,0,0,0,.41.5,1.36,1.36,0,0,0,.67.14,1.87,1.87,0,0,0,.4,0,2.16,2.16,0,0,0,.45-.12v1.2a2.89,2.89,0,0,1-.58.14A4,4,0,0,1,60.81,92.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M63.77,92.53a4.32,4.32,0,0,1-.73-.06,3.17,3.17,0,0,1-.69-.17V91.14a4.83,4.83,0,0,0,.68.17,4.17,4.17,0,0,0,.71.06,1.06,1.06,0,0,0,.64-.15.48.48,0,0,0,.19-.41.4.4,0,0,0-.11-.32.74.74,0,0,0-.32-.17l-.7-.17a1.65,1.65,0,0,1-.93-.54,1.55,1.55,0,0,1-.32-1,1.53,1.53,0,0,1,.57-1.24,2.46,2.46,0,0,1,1.65-.47,6.4,6.4,0,0,1,.64,0l.56.1v1.16c-.19,0-.37-.08-.55-.1a3.48,3.48,0,0,0-.57,0,1.75,1.75,0,0,0-.58.08.72.72,0,0,0-.3.21.48.48,0,0,0-.09.27.4.4,0,0,0,.1.3.79.79,0,0,0,.33.17l.7.17a1.76,1.76,0,0,1,.94.53,1.78,1.78,0,0,1-.26,2.31A2.4,2.4,0,0,1,63.77,92.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic3);
export default __webpack_public_path__ + "static/media/topic_3.61cf33456ac8d307bd52a3c6420bfcb4.svg";
export { ForwardRef as ReactComponent };